import { DISPLAY_TIMEZONE, getCalendarPartsInTimeZone } from '@/utils/displayTimezone'

function pad2(n) {
  return n < 10 ? `0${n}` : String(n)
}

function formatYMD(p) {
  return `${p.y}-${pad2(p.m)}-${pad2(p.d)}`
}

function formatYMDHMS(p, h, i, s) {
  return `${formatYMD(p)} ${pad2(h)}:${pad2(i)}:${pad2(s)}`
}

function addDaysYMD({ y, m, d }, deltaDays) {
  const base = new Date(Date.UTC(Number(y), Number(m) - 1, Number(d)))
  base.setUTCDate(base.getUTCDate() + deltaDays)
  return { y: base.getUTCFullYear(), m: base.getUTCMonth() + 1, d: base.getUTCDate() }
}

function getLagosTodayYMD() {
  const now = new Date()
  const p = getCalendarPartsInTimeZone(now, DISPLAY_TIMEZONE)
  return { y: p.y, m: p.m, d: p.d }
}

function pickRange(picker, startYMD, endYMD) {
  picker.$emit('pick', [formatYMDHMS(startYMD, 0, 0, 0), formatYMDHMS(endYMD, 23, 59, 59)])
}

export const datePickerOptions = {
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const end = getLagosTodayYMD()
        const start = addDaysYMD(end, -6)
        pickRange(picker, start, end)
      },
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const end = getLagosTodayYMD()
        const start = addDaysYMD(end, -29)
        pickRange(picker, start, end)
      },
    },
    {
      text: '最近三个月',
      onClick(picker) {
        const end = getLagosTodayYMD()
        const start = addDaysYMD(end, -89)
        pickRange(picker, start, end)
      },
    },
  ],
}
